import { FixhenLogo } from "./FixhenLogo";
import { Globe2, Mail, Truck } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { FREE_SHIPPING_OVER_CENTS_FALLBACK } from "@/lib/site-config";
import { PaymentMethods } from "./PaymentMethods";

export function SiteFooter() {
  const freeOver = `€${(FREE_SHIPPING_OVER_CENTS_FALLBACK / 100).toFixed(0)}`;
  return (
    <footer className="mt-24 border-t border-border bg-ink text-paper">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <FixhenLogo className="h-10 w-auto" />
            <span className="text-2xl font-black">FIXHEN</span>
          </div>
          <p className="max-w-xs text-sm text-paper/70">
            Genuine and quality-matched parts for modern classic Mercedes-Benz and BMW. Built by enthusiasts, shipped worldwide.
          </p>
        </div>
        <FooterCol title="Shop" links={["Mercedes-Benz", "BMW"]} />
        <FooterCol
          title="Support"
          links={[
            { label: "Contact", to: "/contact" },
            { label: "Shipping", to: "/shipping" },
            { label: "Returns", to: "/returns" },
          ]}
        />
        <FooterCol
          title="Company"
          links={[
            { label: "About FIXHEN", to: "/about" },
            { label: "Blog", to: "/blog" },
            { label: "Contact", to: "/contact" },
            { label: "Partner program", to: "/referral" },
            { label: "Terms", to: "/terms" },
            { label: "Returns policy", to: "/returns" },
          ]}
        />
      </div>
      <PaymentMethods />
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-5 text-xs text-paper/60 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <p>© {new Date().getFullYear()} FIXHEN. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/terms" className="hover:text-paper">Terms</Link>
            <Link to="/returns" className="hover:text-paper">Returns</Link>
            <Link to="/cookies" className="hover:text-paper">Cookies</Link>
            <span className="flex items-center gap-1.5"><Truck className="h-3.5 w-3.5 text-sky-pop" /> Free over {freeOver}</span>
            <span className="flex items-center gap-1.5"><Globe2 className="h-3.5 w-3.5 text-sky-pop" /> Worldwide shipping</span>
            <a href="mailto:info@contact.fixhen.com" className="flex items-center gap-1.5 hover:text-paper"><Mail className="h-3.5 w-3.5" /> info@contact.fixhen.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

type FooterLink = string | { label: string; href?: string; to?: string };
function FooterCol({ title, links }: { title: string; links: FooterLink[] }) {
  return (
    <div>
      <h3 className="mb-3 text-sm font-bold uppercase tracking-widest text-sky-pop">{title}</h3>
      <ul className="space-y-2 text-sm text-paper/75">
        {links.map((l) => {
          const item = typeof l === "string" ? { label: l } : l;
          return (
            <li key={item.label}>
              {item.to ? (
                <Link to={item.to} className="transition-colors hover:text-paper">{item.label}</Link>
              ) : (
                <a href={item.href ?? "#"} className="transition-colors hover:text-paper">{item.label}</a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}